export const eventSettingsTabs: string[] = ['Event Settings', 'Tables and Tickets', 'Auction, FTM, & Raffle'];
